@let line = lineInput();
<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Line Information - {{ line.lineDescription }}</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput">
          <button matButton="elevated" class="inputButton" (click)="showTagsDialog()"
            [class.invalidTags]="invalidTags()">
            <label class="buttonLabel">Tags</label>
          </button>
          @if (invalidTags()) {
            <span class="invalidTagMessage">Please correct the tags for this unit</span>
          }
        </span>
        <div class="halfWidthConfigurationInput">
          <label class="inputLabel">Quantity:</label>
          <input (change)="updateQuantity()" type="number" class="inputTextField" [(ngModel)]="line.quantityExtended"/>
        </div>
      </div>
      <div class="configurationDetailRow">
        @if (isOem()) {
          <span>
            <span class="halfWidthConfigurationInput">
              <label class="halfWidthInputLabel">Customer Item ID:</label>
              <input class="halfWidthInputField" [(ngModel)]="line.customerItemId"/>
            </span>
            <span class="halfWidthConfigurationInput">
              <label class="halfWidthInputLabel">PO Amount:</label>
              <input class="halfWidthInputField" [(ngModel)]="line.customerPoPrice"/>
            </span>
          </span>
        }
      </div>
    </div>
  }
</div>
